import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Box, useTheme } from '@mui/material';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import { actions } from 'services/store/ai';
import { FormulaFields } from 'services/store/ai/types';
import { StoreRootState } from 'services/store/types';
import FormulaFieldSwitch from './FormulaFieldSwitch';
import PrimaryGenreSwitch from './PrimaryGenreSwitch';

const HIDDEN_FORMULA_FIELDS = [FormulaFields.UserLoop];

const fields = Object.values(FormulaFields).filter(
  (field) => !HIDDEN_FORMULA_FIELDS.includes(field)
);

const FormulaFieldsSwitch = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const formula = useSelector((store: StoreRootState) => store.ai.formula);
  const activeFormulaFields = useMemo(
    () => formula.map(({ field }) => field),
    [formula]
  );

  return (
    <Box
      height="100%"
      width={{
        xs: '95vw',
        md: '100%',
      }}
      display="flex"
      flexDirection={{
        xs: 'row',
        md: 'column',
      }}
      justifyContent={{
        xs: 'flex-start',
        md: 'initial',
      }}
      alignItems="center"
      gap={theme.spacing(3)}
      sx={{
        overflow: 'auto',
        whiteSpace: 'nowrap',
      }}
    >
      <PrimaryGenreSwitch />
      {fields.map((field) => (
        <FormulaFieldSwitch
          key={field}
          label={t(aiMusicGenerator.formulaFieldLabels[field])}
          checked={activeFormulaFields.includes(field)}
          onChange={(checked) =>
            checked
              ? dispatch(actions.addFormulaField({ field }))
              : dispatch(actions.deleteFormulaField({ field }))
          }
        />
      ))}
    </Box>
  );
};

export default FormulaFieldsSwitch;
